import request from "@/http";
// 覆盖场景
const getOverlaySceneList = () => {
        return request.get({
            url: "duzikai_api_mgr_public_middle_table",
            data: {
                invoke_method: "public_load_middle_table_list",
                pre_db_para_begin_idx: 0,
                pre_db_para_length_4_list: 10,
                type_middle_app: 20003,
                type_inner_app: 1001,
                pre_db_para_middle_table_name: "public_middle_table_20003",
                is_online: 0
            }
        });
    }
    // 合作伙伴
const getCooperativePartnerList = () => {
    return request.get({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method: "public_load_middle_table_list",
            pre_db_para_begin_idx: 0,
            pre_db_para_length_4_list: 10,
            type_middle_app: 20003,
            type_inner_app: 2002,
            pre_db_para_middle_table_name: "public_middle_table_20003",
            is_online: 0
        }
    });
}
const getTotalData = (data) => {
    let { isloading = false } = data;
    return request.get({
        url: "/indexConfig/pc/show",
        loading: {
            enabled: isloading
        }
    });

}

export default {
    getOverlaySceneList,
    getCooperativePartnerList,
    getTotalData
}
